import "./App.css";
import { NextUIProvider } from "@nextui-org/react";
import { Slide, ToastContainer } from "react-toastify";
import { useApp } from "./useApp";
import { Router } from "./routes/router";
import { AnimatePresence } from "framer-motion";
import "mapbox-gl/dist/mapbox-gl.css";
import "react-day-picker/style.css";
import { CrispChat } from "./components/crispChat/crispChat";

function App() {
  const { navigate } = useApp();
  return (
    <NextUIProvider navigate={navigate}>
      <AnimatePresence >
        <Router />
      </AnimatePresence>
      {/* <CrispChat /> */}
      <ToastContainer
        position="top-right"
        autoClose={6000}
        newestOnTop={false}
        closeOnClick
        transition={Slide}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <CrispChat />
    </NextUIProvider>
  );
}

export default App;
